module.exports = __webpack_public_path__ + "img/residential.ac3c7a22.png";